import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = null;
let inflight = null;

async function load() {
  if (cache) return cache;
  if (inflight) return inflight;
  inflight = fetch(`${API}/public/nav-menus`).then(r => r.json())
    .then(d => { cache = d; inflight = null; return d; })
    .catch(() => { inflight = null; return {}; });
  return inflight;
}

/** Returns the enabled items for a given menu key. */
export function useNavMenu(menuKey) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    load().then(d => setItems((d && d[menuKey]) || []));
  }, [menuKey]);
  return items;
}

/** Force a reload — used after admin saves. */
export function clearNavMenuCache() {
  cache = null;
  inflight = null;
}
